import { atom, } from 'recoil';

export const RolePermissionState = atom({
  key: "RolePermissionState",
  default: null,
});